













import Vue from "vue";

import JzInputRadio from "./JzInputRadio.vue";

type RadioOptions = { value: string | number | boolean; label: string };

interface Data {
  currentSelection: string | number | boolean;
}

interface Methods {
  onRadioClick: (opt: RadioOptions) => void;
}

interface Props {
  value: string | number | boolean;
  options: RadioOptions[];
}

export default Vue.extend<Data, Methods, {}, Props>({
  name: "JzInputRadioGroup",
  components: { JzInputRadio },

  props: {
    value: { type: [String, Number, Boolean], required: true },
    options: { type: Array, required: true }
  },

  data: function() {
    return { currentSelection: this.value };
  },

  computed: {},

  methods: {
    onRadioClick(opt) {
      this.currentSelection = opt.value;
      this.$emit("input", opt.value);
    }
  }
});
